<template>
  <div
    ref="chip"
    class="ir-chip"
    :class="{ 'chip-selected': selected, 'chip-disabled': disabled }"
    @mousedown="startRippleEffect"
    @click="selectChip"
  >
    {{ value }}
    <slot name="content"></slot>
    <span v-if="closable" class="close-btn" @click.stop="closeChip"
      >&#10005;</span
    >
    <div v-if="ripple" class="ir-ripple" :style="ripple.style"></div>
  </div>
</template>

<script>
export default {
  name: 'IRChip',
  props: {
    closable: Boolean,
    value: [String, Number],
    selected: Boolean,
    disabled: Boolean
  },
  data() {
    return {
      ripple: null
    };
  },
  methods: {
    selectChip() {
      if (!this.disabled) {
        this.$emit('update:selected', this.value);
      }
    },
    closeChip() {
      this.$emit('close', this.value);
    },
    startRippleEffect(event) {
      if (this.disabled) {
        return;
      }
      const button = this.$refs.chip;
      const rect = button.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const style = {
        top: `${event.clientY - rect.top - size / 2}px`,
        left: `${event.clientX - rect.left - size / 2}px`,
        width: `${size}px`,
        height: `${size}px`
      };
      this.ripple = { style };
      this.clearRipple();
    },
    clearRipple() {
      setTimeout(() => {
        this.ripple.style.opacity = 0;
        setTimeout(() => {
          this.ripple = null;
        }, 1000);
      }, 100);
    }
  }
};
</script>

<style scoped lang="less">
.ir-chip {
  padding: 0 12px;
  height: 32px;
  border-radius: 4px;
  position: relative;
  box-shadow: inset 0 0 0 1px #cbd5e1;
  color: #333;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  user-select: none;
  overflow: hidden;

  &:hover:before {
    opacity: 0.08;
  }

  &:not(.chip-disabled):before {
    background-color: currentColor;
    border-radius: inherit;
    bottom: 0;
    color: inherit;
    content: '';
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  }
  &.chip-disabled {
    opacity: 0.5;
    cursor: default;
  }
}

.chip-selected {
  background: var(--primary-color);
  color: var(--white-color);
  box-shadow: none;
}

.close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #ccc;
  color: #fff;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: #b1b1b1;
  }
}
.ir-ripple {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  transform: scale(0);
  animation: ripple-effect 400ms linear forwards;
}

@keyframes ripple-effect {
  to {
    transform: scale(4);
    opacity: 0;
  }
}
</style>
